import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

/* private ContactFunctionsSettings Types */
import {
  Settings,
  _ContactFunctionsSettings
} from '../namespace-helper'

import _ from 'lodash'

const selectedContactFunctionTemplate = {
  id: 0,
  name: '',
  description: ''
}

export default {
  namespaced: true,
  state: {
    contactFunctions: [],
    allContactFunctions: [],
    selectedContactFunction: _.cloneDeep(selectedContactFunctionTemplate),
    openNewContactFunctionDialog: false
  },
  mutations: {
    [_ContactFunctionsSettings.mutations.setContactFunctions] (state, payload) {
      state.contactFunctions = payload
    },
    [_ContactFunctionsSettings.mutations.setAllContactFunctions] (state, payload) {
      state.allContactFunctions = payload
    },
    [_ContactFunctionsSettings.mutations.setSelectedContactFunction] (state, payload) {
      if (payload !== null) {
        state.selectedContactFunction = payload
      } else {
        state.selectedContactFunction = _.cloneDeep(selectedContactFunctionTemplate)
      }
    },
    [_ContactFunctionsSettings.mutations.setOpenCloseNewContactFunctionDialogState] (state) {
      state.openNewContactFunctionDialog = !state.openNewContactFunctionDialog
    }
  },
  actions: {
    [_ContactFunctionsSettings.actions.saveContactFunction] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)

      if (payload.id === 0) {
        var url = API_URL + '/api/v1/contactFunctions'

        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      } else {
        url = API_URL + '/api/v1/contactFunctions/' + payload.id

        axios.put(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      }
    },
    [_ContactFunctionsSettings.actions.loadContactFunctions] (context, payload) {
      console.log('loadContactFunctions: ' + JSON.stringify(payload))
      console.log('loadContactFunctions: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/contactFunctions?limit=' + payload.limit + '&page=' + payload.page + '&search=' + payload.search + '&searchFields=id:like;name:like;description:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_ContactFunctionsSettings.mutations.setContactFunctions, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_ContactFunctionsSettings.actions.loadAllContactFunctions] (context, payload) {
      var url = API_URL + '/api/v1/contactFunctions'

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_ContactFunctionsSettings.mutations.setAllContactFunctions, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_ContactFunctionsSettings.actions.openCloseNewContactFunctionDialog] ({ commit }) {
      commit(_ContactFunctionsSettings.mutations.setOpenCloseNewContactFunctionDialogState)
    },
    [_ContactFunctionsSettings.actions.setSelectedContactFunction] ({ commit }, payload) {
      commit(_ContactFunctionsSettings.mutations.setSelectedContactFunction, payload)
    },
    [_ContactFunctionsSettings.actions.resetState] ({ commit }, payload) {
      commit(_ContactFunctionsSettings.mutations.setContactFunctions, [])
      commit(_ContactFunctionsSettings.mutations.setAllContactFunctions, [])
      commit(_ContactFunctionsSettings.mutations.setSelectedContactFunction, null)
    }
  },
  getters: {
    [_ContactFunctionsSettings.getters.contactFunctions] (state) {
      return state.contactFunctions
    },
    [_ContactFunctionsSettings.getters.getAllContactFunctions] (state) {
      return state.allContactFunctions
    },
    [_ContactFunctionsSettings.getters.getOpenNewContactFunctionDialogState] (state) {
      return state.openNewContactFunctionDialog
    },
    [_ContactFunctionsSettings.getters.getSelectedContactFunction] (state) {
      return state.selectedContactFunction
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/Settings/contactFunctions.js